/** Story layer (prefix sty.*): meet sheets, Character Cards (Residents), narration bubble, reactions, chapter comics, storybook, bedtime. */
export const en = {
  // meet sheet + Character Card
  'sty.meet.someone': 'Someone wants to meet you!',
  'sty.meet.next': 'Next',
  'sty.meet.draw': "Yes, let's draw!",
  'sty.meet.drawNow': 'Draw now',
  'sty.meet.hearStory': 'Hear the story',
  'sty.meet.theEnd': 'The end!',
  // Settings: the story is optional
  'sty.set.mode': 'Story before lessons',
  'sty.set.always': 'Always',
  'sty.set.first': 'First time only',
  'sty.set.off': 'Off',
  'sty.set.narration': 'Characters narrate while drawing',
  'sty.set.paused': 'Paused: {name} chose "Draw now" 3 times in a row. Stories are still behind the 📖 button.',
  'sty.set.resume': 'Offer stories again',
  'sty.meet.quirk': 'Little habit',
  'sty.meet.fav': 'Loves',
  'sty.meet.prop': 'Always has',
  'sty.card.signature': 'Signature',
  'sty.card.got': 'Character Card collected!',
  'sty.card.from': 'from {world}',
  // Residents tab (Collect)
  'sty.tab.residents': 'Residents',
  'sty.res.count': '{n} of {total} friends met',
  'sty.res.mystery': 'Not met yet',
  'sty.res.empty': 'Start a lesson to meet the first resident!',
  'sty.res.draw': 'Draw me again',
  'sty.res.voice': 'Hear my voice',
  // narration bubble
  'sty.narr.tip': 'Drawing tip',
  'sty.narr.tipShow': 'Show the drawing tip',
  'sty.narr.tipHide': 'Hide the drawing tip',
  // reactions
  'sty.react.label': '{name} says',
  // chapter comics
  'sty.comic.read': 'Read the comic',
  'sty.comic.start': 'Chapter {n} begins',
  'sty.comic.end': 'Chapter {n} ends',
  'sty.comic.panel': 'Panel {n} of {total}',
  'sty.comic.prev': 'Previous panel',
  'sty.comic.next': 'Next panel',
  'sty.comic.replay': 'Replay chapter {n}',
  'sty.comic.close': 'Close the comic',
  'sty.finale.title': 'The grand finale',
  'sty.finale.theEnd': 'The End… for now!',
  // storybook (grown-ups corner)
  'sty.book.tab': 'Storybook',
  'sty.book.title': "{name}'s storybook",
  'sty.book.by': 'Written and drawn by {name}',
  'sty.book.intro': 'Every drawing {name} makes becomes a page in the world\'s story. Read it together, share it, or save it as a PDF.',
  'sty.book.empty': '{name} has no drawings in this world yet. Each lesson adds a picture to the story.',
  'sty.book.world': 'Choose a world',
  'sty.book.page': 'Page {n} of {total}',
  'sty.book.prev': 'Previous page',
  'sty.book.next': 'Next page',
  'sty.book.share': 'Share',
  'sty.book.pdf': 'Save as PDF',
  'sty.book.pdfBusy': 'Binding the book…',
  'sty.book.pdfDone': 'Your storybook PDF is ready',
  'sty.book.pdfFail': "Couldn't make the PDF. Please try again.",
  'sty.book.print': 'Printed hardcover: coming soon',
  'sty.book.endTitle': 'The End',
  'sty.book.endBody': 'A story with {n} drawings by {name}.',
  'sty.book.yourArt': "{name}'s drawing",
  'sty.book.shareTitle': "{name}'s storybook",
  'sty.book.shareMsg': '{name} drew a whole storybook: "{title}" ({n} drawings).',
  'sty.book.chapter': 'Chapter {n}',
  // bedtime
  'sty.bed.open': 'Bedtime story',
  'sty.bed.title': 'Bedtime story',
  'sty.bed.timer': 'Sleep timer',
  'sty.bed.min': '{n} min',
  'sty.bed.none': 'Off',
  'sty.bed.pause': 'Pause',
  'sty.bed.play': 'Play',
  'sty.bed.close': 'Good night',
  'sty.bed.done': 'Sweet dreams, {name}.',
  'sty.bed.timeUp': 'Time to sleep. Good night, {name}.',
  'sty.bed.left': '{n} min left',
} as const;

export const vi: Record<keyof typeof en, string> = {
  'sty.meet.someone': 'Có một bạn muốn làm quen với con!',
  'sty.meet.next': 'Tiếp',
  'sty.meet.draw': 'Vẽ thôi nào!',
  'sty.meet.drawNow': 'Vẽ luôn',
  'sty.meet.hearStory': 'Nghe kể chuyện',
  'sty.meet.theEnd': 'Hết truyện rồi!',
  'sty.set.mode': 'Kể chuyện trước bài vẽ',
  'sty.set.always': 'Luôn luôn',
  'sty.set.first': 'Chỉ lần đầu',
  'sty.set.off': 'Tắt',
  'sty.set.narration': 'Nhân vật kể chuyện khi vẽ',
  'sty.set.paused': 'Đang tạm dừng: {name} đã chọn "Vẽ luôn" 3 lần liền. Truyện vẫn nằm sau nút 📖.',
  'sty.set.resume': 'Mời nghe truyện lại',
  'sty.meet.quirk': 'Tật nhỏ',
  'sty.meet.fav': 'Thích nhất',
  'sty.meet.prop': 'Luôn mang theo',
  'sty.card.signature': 'Chữ ký',
  'sty.card.got': 'Con nhận được Thẻ nhân vật!',
  'sty.card.from': 'ở {world}',
  'sty.tab.residents': 'Cư dân',
  'sty.res.count': 'Đã làm quen {n}/{total} bạn',
  'sty.res.mystery': 'Chưa gặp',
  'sty.res.empty': 'Bắt đầu một bài vẽ để gặp cư dân đầu tiên nhé!',
  'sty.res.draw': 'Vẽ tớ lần nữa',
  'sty.res.voice': 'Nghe giọng tớ',
  'sty.narr.tip': 'Mẹo vẽ',
  'sty.narr.tipShow': 'Hiện mẹo vẽ',
  'sty.narr.tipHide': 'Ẩn mẹo vẽ',
  'sty.react.label': '{name} nói',
  'sty.comic.read': 'Đọc truyện tranh',
  'sty.comic.start': 'Chương {n} bắt đầu',
  'sty.comic.end': 'Chương {n} kết thúc',
  'sty.comic.panel': 'Khung {n}/{total}',
  'sty.comic.prev': 'Khung trước',
  'sty.comic.next': 'Khung sau',
  'sty.comic.replay': 'Xem lại chương {n}',
  'sty.comic.close': 'Đóng truyện tranh',
  'sty.finale.title': 'Đoạn kết thật lớn',
  'sty.finale.theEnd': 'Hết… còn tiếp nữa nha!',
  'sty.book.tab': 'Truyện của con',
  'sty.book.title': 'Cuốn truyện của {name}',
  'sty.book.by': 'Tác giả và hoạ sĩ: {name}',
  'sty.book.intro': 'Mỗi bức tranh {name} vẽ sẽ thành một trang trong câu chuyện của thế giới. Cùng con đọc, chia sẻ hoặc lưu thành PDF.',
  'sty.book.empty': '{name} chưa có tranh nào ở thế giới này. Mỗi bài vẽ sẽ thêm một bức tranh vào câu chuyện.',
  'sty.book.world': 'Chọn thế giới',
  'sty.book.page': 'Trang {n}/{total}',
  'sty.book.prev': 'Trang trước',
  'sty.book.next': 'Trang sau',
  'sty.book.share': 'Chia sẻ',
  'sty.book.pdf': 'Lưu PDF',
  'sty.book.pdfBusy': 'Đang đóng sách…',
  'sty.book.pdfDone': 'Cuốn truyện PDF đã sẵn sàng',
  'sty.book.pdfFail': 'Chưa tạo được PDF. Thử lại nhé.',
  'sty.book.print': 'Sách in bìa cứng: sắp ra mắt',
  'sty.book.endTitle': 'Hết',
  'sty.book.endBody': 'Một câu chuyện với {n} bức tranh của {name}.',
  'sty.book.yourArt': 'Tranh của {name}',
  'sty.book.shareTitle': 'Cuốn truyện của {name}',
  'sty.book.shareMsg': '{name} đã vẽ cả một cuốn truyện: "{title}" ({n} bức tranh).',
  'sty.book.chapter': 'Chương {n}',
  'sty.bed.open': 'Truyện trước giờ ngủ',
  'sty.bed.title': 'Truyện trước giờ ngủ',
  'sty.bed.timer': 'Hẹn giờ ngủ',
  'sty.bed.min': '{n} phút',
  'sty.bed.none': 'Tắt',
  'sty.bed.pause': 'Tạm dừng',
  'sty.bed.play': 'Đọc tiếp',
  'sty.bed.close': 'Chúc ngủ ngon',
  'sty.bed.done': 'Ngủ ngon nhé, {name}.',
  'sty.bed.timeUp': 'Đến giờ ngủ rồi. Chúc {name} ngủ ngon.',
  'sty.bed.left': 'Còn {n} phút',
};
